import request from '@/utils/request'

// 查询列表
export function apiPoDeliveryNoticeLinesList (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/list',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiItemCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 根据管控物料查询目的仓
export function apiGetSubInvByItem (query) {
  return request({
    url: '/po/poDeliveryNoticeLines/getSubInvByItem',
    method: 'get',
    params: query
  })
}

// 查询要货通知行日志
export function apiListDeliveryLog (query) {
  return request({
    url: '/po/poDeliveryNoticeLines/listDeliveryLog',
    method: 'get',
    params: query
  })
}

// 关闭
export function apiPoDeliveryNoticeLinesClose (data) {
  return request({
    url: `/po/poDeliveryNoticeLines/close`,
    method: 'post',
    data: data
  })
}

// 更新双方确认日期
export function apiPoDeliveryNoticeLinesUpdate (data) {
  return request({
    url: `/po/poDeliveryNoticeLines/update`,
    method: 'post',
    data: data
  })
}

// 查询要货单权限
export function apiPoGetPoPermissions (data) {
  return request({
    url: `/po/poDeliveryNoticeLines/getPoPermissions`,
    method: 'post',
    data: data
  })
}

// 新增
export function apiPoDeliveryNoticeLinesAddList (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/addList',
    method: 'post',
    data: data
  })
}

// 公司主体下拉
export function apiPoGetMainBodyCombobox (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/mainBodyCombobox',
    method: 'post',
    data: data
  })
}

// 获取拆分要货单号
export function apiPoGetSplitDeliveryNo (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/getSplitDeliveryNo',
    method: 'post',
    data: data
  })
}

// 拆分
export function apiPoDeliveryNoticeLinesSplit (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/split',
    method: 'post',
    data: data
  })
}

// 驳回
export function apiPoDeliveryNoticeLinesRejected (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/rejected',
    method: 'post',
    data: data
  })
}

// 关闭
export function apiCloseNoChangeAll (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/closeNoChangeAll',
    method: 'post',
    data: data
  })
}

// 审核
export function apiPoDeliveryNoticeLinesAudit (data) {
  return request({
    url: '/po/poDeliveryNoticeLines/audit',
    method: 'post',
    data: data
  })
}

// 导出
export function apiV2Export (data) {
  return request({
    url: `/po/poDeliveryNoticeLines/v2/export`,
    method: 'post',
    data: data
  })
}
